"use client";

import React from "react";
import { useAtomValue } from "jotai";
import { useWatch } from "react-hook-form";
import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel, Navigation } from "swiper/modules";

import { coursePackagesAtom } from "@/store/course";

import CourseSection from "../course-section";
import CourseSwiperNav from "../course-swiper-nav";
import BundleCourse from "./bundle-course";

function CourseBundle({ courses }) {
  const prevNavRef = React.useRef(null);
  const nextNavRef = React.useRef(null);

  const packages = useAtomValue(coursePackagesAtom);
  const packageId = useWatch({ name: "packageId" });

  const [swiper, setSwiper] = React.useState(null);

  if (!courses.length) return null;

  const currentPackage = packages.find((pkg) => packageId === pkg.packageId);

  return (
    <CourseSection
      id="included-courses"
      title="Included in this Course"
      action={
        <CourseSwiperNav
          swiper={swiper}
          prevNavRef={prevNavRef}
          nextNavRef={nextNavRef}
        />
      }
    >
      <Swiper
        modules={[Navigation, Mousewheel]}
        spaceBetween={16}
        slidesOffsetAfter={16}
        slidesPerView={1.6}
        onSwiper={setSwiper}
        mousewheel={{ forceToAxis: true }}
        breakpoints={{
          600: {
            slidesPerView: 2,
            slidesOffsetAfter: 0,
          },
        }}
        className="-mr-4 lg:mr-0"
      >
        {courses.map((course) => (
          <SwiperSlide key={course.courseSlug}>
            <BundleCourse
              course={{
                ...course,
                validity:
                  course.validity || currentPackage?.packageValidityInDays,
              }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </CourseSection>
  );
}

export default CourseBundle;
